<template>
  <div class="details">
    <div class="intro">
      <h4>Activity Log</h4>
    </div>
    <Table :items="updateDetails" :attributes="tableAttributes" :options="tableOptions" @head="sendLink"></Table>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';

export default {
  name: 'SupporterViewUpdateDetails',
  components: {
    Table,
  },

  data() {
    return {
      contact: null,
      tableOptions: {
        // headAction: this.canEdit ? 'Send Link to Supporter' : '',
        pages: [5],
      },
      tableAttributes: [
        { name: 'createdAt', label: 'Date', type: 'date' },
        { name: 'email', label: 'Email' },
        { name: 'private.ResponseFromPP', label: 'Update CC', type: 'tick' },
        { name: 'FLAG_isExported', label: 'Exported', type: 'tick' },
      ],
    };
  },

  props: {
    updateDetails: Array,
    canEdit: Boolean,
  },
  methods: {
    sendLink() {
      this.$emit('sendLink');
    },
  },
};
</script>
